import React from 'react';
import styled, { css } from 'styled-components';

export const Container = styled.section<{
  $height?: boolean;
}>`
  ${({ $height }) =>
    $height &&
    css`
      overflow-y: auto;
      max-height: 810px;
      max-width: 1440px;
    `}
`;

export const EmbedComponent = styled.section<{
  $height?: boolean;
}>`
  overflow: auto;
`;

export type HtmlPanelProps = {
  label: string;
  htmlEmbed: string;
  height: boolean; //True: Fixed height, False: Responsive height
  padding: boolean; //True: With padding, False: No padding
};

export const HtmlEmbedPanel: React.FC<HtmlPanelProps> = (data) => {
  return (
    <Container $height={data.height}>
      <EmbedComponent
        dangerouslySetInnerHTML={{
          __html: data.htmlEmbed,
        }}
      />
    </Container>
  );
};
